<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show1"
        />

        <div class="row container">
            <div class="col-12 my-4">
                <b-button
                    variant="primary"
                    id="order"
                    @click="make"
                >
                    {{ $t('autoOrder.title') }}
                </b-button>
            </div>
        </div>

        <div v-if="getOrders.length > 0" class="row">
            <div class="col-12">
                <OrderListTable />
            </div>
        </div>

        <ModalMakeOrder
            id="make_order"
            text="autoOrder.modalTitle"
            @saleNotFound="saleNotFound"
            @notNeedOrder="notNeedOrder"
        />

    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import {mapActions, mapGetters} from "vuex";
import OrderListTable from "@/components/OrderListTable.vue";
import ModalMakeOrder from "@/components/ModalMakeOrder.vue";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "AutoOrder",
    components: {ModalMakeOrder, OrderListTable, Row, Modal},
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'autoOrder.title', url: 'orders'},
            ],
            modalText: '',
            search: {
                after: '',
                before: '',
                orderId: null,
                supplierId: null,
                page: 1
            },
        }
    },
    computed: {
        ...mapGetters(['getOrders'])
    },
    methods: {
        ...mapActions(['pushOrder','fetchOrders', 'setBreadcrumbItems']),
        make() {
            this.$bvModal.show('make_order')
        },
        saleNotFound(reason) {
            this.$root.showOverlay = false
            this.isLoading = false

            if (reason === 'There is no sale for the selected period') {
                this.modalText = this.$t('autoOrder.noSale')
            } else {
                this.modalText = reason
            }

            this.$bvModal.show('modal_show1')
        },
        notNeedOrder() {
            this.$root.showOverlay = false
            this.isLoading = false
            this.modalText = this.$t('autoOrder.noNeedOrder')
            this.$bvModal.show('modal_show1')
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this.fetchOrders(this.search)
            .then(() => {
                this.$root.showOverlay = false
            })
            .finally(() => {
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>

</style>
